class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onAddonClick = this.handleAddonClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.notification.addEventListener('click', this.onAddonClick);
    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
      if (!closeButton.classList.contains('ubc-cart-addon__button')) {
        closeButton.addEventListener('click', this.close.bind(this));
      }
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  async handleAddonClick(evt) {
    const button = evt.target.closest('.ubc-cart-addon__button');
    if (!button || button.disabled) return;

    evt.preventDefault();
    evt.stopPropagation();

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const response = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.addonVariantId), quantity: 1 }],
          sections: 'cart-notification-button,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error('Unable to add item');
      const state = await response.json();

      if (state.sections) {
        const cartButton = document.getElementById('cart-notification-button');
        const cartBubble = document.getElementById('cart-icon-bubble');
        if (cartButton && state.sections['cart-notification-button']) {
          cartButton.innerHTML = this.getSectionInnerHTML(state.sections['cart-notification-button']);
        }
        if (cartBubble && state.sections['cart-icon-bubble']) {
          cartBubble.innerHTML = this.getSectionInnerHTML(state.sections['cart-icon-bubble']);
        }
      }

      button.textContent = 'Added ✓';
      button.classList.add('is-added');
      button.setAttribute('aria-label', 'Added to cart');
    } catch (error) {
      button.disabled = false;
      button.textContent = originalText;
      button.classList.add('has-error');
      button.setAttribute('aria-label', 'Could not add item. Try again.');
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
